var exports = {
  "container": "xf0b3b88a--957911--container",
  "container--top3": "xf0b3b88a--957911--container--top3",
  "container--colorized": "xf0b3b88a--957911--container--colorized",
  "represent": "xf0b3b88a--957911--represent",
  "content": "xf0b3b88a--957911--content",
  "media": "xf0b3b88a--957911--media",
};

module.exports = exports;
